import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.m6q_1 = id;
        this.n6q_1 = name;
        this.o6q_1 = email;
        this.p6q_1 = badge;
        this.q6q_1 = callSignAdjective;
        this.r6q_1 = callSignNoun;
        this.s6q_1 = imageURL;
        this.t6q_1 = avatarType;
        this.u6q_1 = unvalidatedEmails;
        this.v6q_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.m6q_1.toString() + ', name=' + this.n6q_1 + ', email=' + this.o6q_1 + ', badge=' + toString(this.p6q_1) + ', callSignAdjective=' + this.q6q_1 + ', callSignNoun=' + this.r6q_1 + ', imageURL=' + toString(this.s6q_1) + ', avatarType=' + toString(this.t6q_1) + ', unvalidatedEmails=' + toString(this.u6q_1) + ', pins=' + toString(this.v6q_1) + ')';
      }
      hashCode() {
        var result = this.m6q_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.n6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o6q_1) | 0;
        result = imul(result, 31) + hashCode(this.p6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r6q_1) | 0;
        result = imul(result, 31) + hashCode(this.s6q_1) | 0;
        result = imul(result, 31) + hashCode(this.t6q_1) | 0;
        result = imul(result, 31) + hashCode(this.u6q_1) | 0;
        result = imul(result, 31) + hashCode(this.v6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.m6q_1.equals(other.m6q_1))
          return false;
        if (!(this.n6q_1 === other.n6q_1))
          return false;
        if (!(this.o6q_1 === other.o6q_1))
          return false;
        if (!equals(this.p6q_1, other.p6q_1))
          return false;
        if (!(this.q6q_1 === other.q6q_1))
          return false;
        if (!(this.r6q_1 === other.r6q_1))
          return false;
        if (!equals(this.s6q_1, other.s6q_1))
          return false;
        if (!equals(this.t6q_1, other.t6q_1))
          return false;
        if (!equals(this.u6q_1, other.u6q_1))
          return false;
        if (!equals(this.v6q_1, other.v6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
